import { render, staticRenderFns } from "./TabelaContratosRelacionadosDenuncia.vue?vue&type=template&id=00175cef&scoped=true&lang=pug"
import script from "./TabelaContratosRelacionadosDenuncia.vue?vue&type=script&lang=js"
export * from "./TabelaContratosRelacionadosDenuncia.vue?vue&type=script&lang=js"
import style0 from "./TabelaContratosRelacionadosDenuncia.vue?vue&type=style&index=0&id=00175cef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00175cef",
  null
  
)

export default component.exports